__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@sista/service-sprava-textu-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (() => (__webpack_require__(17041))), 1);
			register("@emotion/styled", "11.14.1", () => (() => (__webpack_require__(65891))), 1);
			register("@mdi/js", "7.4.47", () => (() => (__webpack_require__(80289))), 1);
			register("@mui/icons-material", "5.18.0", () => (() => (__webpack_require__(83003))), 1);
			register("@mui/lab", "5.0.0-alpha.177", () => (() => (__webpack_require__(20033))), 1);
			register("@mui/material", "5.18.0", () => (() => (__webpack_require__(56354))), 1);
			register("@mui/system", "5.18.0", () => (() => (__webpack_require__(46728))), 1);
			register("@mui/x-date-pickers", "6.20.2", () => (() => (__webpack_require__(40959))), 1);
			register("@sista/dista-ui", "3.10.2", () => (() => (__webpack_require__(47938))), 1);
			register("@sista/fe-commons", "5.6.1", () => (() => (__webpack_require__(700))), 1);
			register("@sista/idm-client", "1.5.0", () => (() => (__webpack_require__(46159))), 1);
			register("@sista/menu", "104.0.0", () => (() => (__webpack_require__(71493))), 1);
			register("@sista/notis-push", "1.15.0", () => (() => (__webpack_require__(64089))), 1);
			register("i18next-http-backend", "2.7.3", () => (() => (__webpack_require__(10944))), 1);
			register("i18next", "22.5.1", () => (() => (__webpack_require__(35529))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(8143))), 1);
			register("react-i18next", "12.3.1", () => (() => (__webpack_require__(58791))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(30758))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};